import type { LineCard, VendorScorecard } from './types';

/**
 * Cache-backed vendor fetchers. 503 means bi_export hasn't produced the file
 * yet (first cron tick after a fresh deploy) — surface as a friendly message.
 */

const FETCH_TIMEOUT_MS = 30_000;

function isMock(): boolean {
  return import.meta.env.VITE_USE_MOCKS === '1';
}

async function getJSON<T>(url: string): Promise<T> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);
  try {
    const res = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
    if (res.status === 503) {
      throw new Error('Proveedores en preparación — el primer cron de bi_export aún no produce los archivos.');
    }
    if (!res.ok) {
      throw new Error(`${url} failed: ${res.status}`);
    }
    return (await res.json()) as T;
  } catch (err) {
    if (err instanceof DOMException && err.name === 'AbortError') {
      throw new Error(`${url} timed out after ${FETCH_TIMEOUT_MS}ms`);
    }
    throw err;
  } finally {
    clearTimeout(timer);
  }
}

export async function fetchVendors(): Promise<VendorScorecard[]> {
  if (isMock()) return [];
  return getJSON<VendorScorecard[]>('/api/vendors');
}

export async function fetchLineCards(): Promise<LineCard[]> {
  if (isMock()) return [];
  return getJSON<LineCard[]>('/api/line-cards');
}
